import ModalLayout from './ModalLayout';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';
import { ModalLayoutProps } from '.';
import { HelloMuiButton } from 'components/Mui';

const FreePlanUpgradeModal = (props: ModalLayoutProps) => {
    const { visible, onClose } = props;
    const navigate = useNavigate();

    const onUpgradeClick = () => {
        onClose();
        navigate(`${ROUTES.SETTING}?tab=2`);
    };

    return (
        <ModalLayout visible={visible} onClose={onClose}>
            <div className="md:w-[550px] rounded-[10px] px-[22px] pt-[60px] pb-[10px] bg-white">
                <div className="flex flex-col gap-[5px]">
                    <div className="px-[38px] text-center pb-[15px]">
                        <img src="/image/Upgrade-Plan.png" className="mx-auto pb-[35px]" />{' '}
                        <div className="text-[18px] font-medium leading-[24px] pb-[10px]">Upgrade Now to See All Listings</div>
                        <div className="text-[14px] text-opacity-80 leading-[24px]">
                            Get access to all listings and unlock the full potential of our platform
                        </div>
                    </div>

                    <HelloMuiButton
                        sx={{
                            borderRadius: '8px',
                            height: '42px',
                            width: '100%',
                        }}
                        variant="contained"
                        className="!bg-gradient-green !font-medium"
                        onClick={onUpgradeClick}
                    >
                        Upgrade Now
                    </HelloMuiButton>

                    <HelloMuiButton
                        sx={{
                            borderRadius: '8px',
                            height: '42px',
                            width: '100%',
                        }}
                        className="!text-my-black !font-medium"
                        onClick={onClose}
                    >
                        Maybe Later
                    </HelloMuiButton>
                </div>
            </div>
        </ModalLayout>
    );
};

export default FreePlanUpgradeModal;
